import i18n from "@/i18n";

export enum LabTestStatus {
  ReadyForTesting = "readyForTesting",
  InTesting = "inTesting",
  Completed = "completed",
  Aborted = "aborted",
}

export const getLabTestStatusLabels = (): Record<LabTestStatus, string> => ({
  [LabTestStatus.ReadyForTesting]: i18n.t("common:labTestStatus.readyForTesting"),
  [LabTestStatus.InTesting]: i18n.t("common:labTestStatus.inTesting"),
  [LabTestStatus.Completed]: i18n.t("common:labTestStatus.completed"),
  [LabTestStatus.Aborted]: i18n.t("common:labTestStatus.aborted"),
});
